import { styled } from '@nykaa/ui-components';
import { APP_MIGRATION_TOP_BANNER_HEIGHT } from 'shared/styles/base';

export const BannerContainer = styled.div`
  width: 100%;
  min-height: ${APP_MIGRATION_TOP_BANNER_HEIGHT}px;
  padding: 0 ${({ theme }) => theme.spacing.spacing40} 0 ${({ theme }) => theme.spacing.spacing60};
  padding-top: calc(${({ theme }) => theme.spacing.spacing60} + env(safe-area-inset-top, 0px));
  padding-bottom: ${({ theme }) => theme.spacing.spacing60};
  background-color: #001325;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.spacing60};
  box-sizing: border-box;
`;

export const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.spacing60};
  flex: 1;
  min-width: 0;
`;

export const AppIconContainer = styled.div`
  width: 44px;
  height: 42px;
  min-width: 44px;
  border-radius: ${({ theme }) => theme.borders.radius30};
  overflow: hidden;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 29px;
    height: auto;
    object-fit: contain;
  }
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  max-width: 174px;
`;

export const BannerText = styled.span`
  ${({ theme }) => theme.typography.type120};
  color: #ffffff;
  font-feature-settings: 'lnum' 1, 'pnum' 1;
`;

export const Title = styled.span`
  ${({ theme }) => theme.typography.type120};
  color: #ffffff;
`;

export const Subtitle = styled.span`
  ${({ theme }) => theme.typography.type100};
  color: rgba(255, 255, 255, 0.7);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.spacing80};
  flex-shrink: 0;
`;

export const CTAButton = styled.button`
  padding: ${({ theme }) => `${theme.spacing.spacing40} ${theme.spacing.spacing60}`};
  border-radius: ${({ theme }) => theme.borders.radius10};
  background: #ffffff;
  border: none;
  cursor: pointer;
  ${({ theme }) => theme.typography.type122};
  letter-spacing: 0.1px;
  color: rgba(0, 19, 37, 0.92);
  white-space: nowrap;
  text-align: center;
  font-feature-settings: 'lnum' 1, 'pnum' 1;

  &:active {
    opacity: 0.9;
    transform: scale(0.98);
  }

  transition: opacity 0.2s ease, transform 0.1s ease;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;

  svg {
    width: 24px;
    height: 24px;
  }

  &:active {
    opacity: 0.7;
  }
`;
